module.exports = __webpack_public_path__ + "img/reef-intro.aac447f0.png";